/*
 * @Author: 陈大仙人
 * @Date: 2024-01-10 17:03:11
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-11 11:49:08
 * @FilePath: /akx-pc-main/src/login/ad.js
 */
export default [{
  phone: '18051002087',
  title: '开通勤商',
  tipImg: '//img.ai.kxkx888.com/pc/ad/ad-qs-tip.jpg',
  banner: '//img.ai.kxkx888.com/pc/ad/ad-qs.gif',
  content: ['//img.ai.kxkx888.com/pc/ad/ad-qs-1.jpg', '//img.ai.kxkx888.com/pc/ad/ad-qs-2.jpg', '//img.ai.kxkx888.com/pc/ad/ad-qs-3.jpg', '//img.ai.kxkx888.com/pc/ad/ad-qs-4.jpg'],
  event: (index, $vue) => {
    $vue.visable = true;
  },
}, {
  title: '开通收银系统',
  phone: '18051002087',
  tipImg: '//img.ai.kxkx888.com/pc/ad/ad-pos-tip.jpg',
  banner: '//img.ai.kxkx888.com/pc/ad/ad-pos.gif',
  content: ['//img.ai.kxkx888.com/pc/ad/ad-pos-1.jpg', '//img.ai.kxkx888.com/pc/ad/ad-pos-2.jpg'],
  event: (index, $vue) => {
    $vue.visable = true;
  },
}]